import SpotifyPlayer from "../../../../src/components/SpotifyPlayer";
import React from 'react';
export default {
  SpotifyPlayer,
  React
};